// extracted by mini-css-extract-plugin
module.exports = {"button":"ActionButton_button__1pRQW","primary":"ActionButton_primary__NrcJe","secondary":"ActionButton_secondary__rP_wK","tertiary":"ActionButton_tertiary__DbYd_"};